/**
 * Brand Colors
 */
export const IEDU_BLUE = '#15bbe7';
export const IEDU_PINK = '#ee3a81';
export const IEDU_PINK_HOVER = '#f1478b';
export const IEDU_GREEN = '#00d045';
export const IEDU_GREEN_HOVER = '#18e05b';
export const IEDU_NAVY = '#3c63ae';
export const IEDU_BLACK = '#000000';
export const IEDU_WHITE = '#ffffff';


/**
 * Brand Colors
 */
export const CyanProcess = '#15bbe7';
export const CerisePink = '#ee3a81';
export const FrenchRose = '#f1478b';
export const VividMalachite = '#00d045';
export const Malachite = '#18e05b';
export const BlueYonder = '#3c63ae';
export const Black = '#000000';
export const White = '#ffffff';
export const Lotion = '#FDFDFD';
export const Cultured = '#F6F6F6';
export const ChineseSilver = '#c9c9c9';
export const SilverSand = '#C5C5C5';
export const UFOGreen = '#4DD951';
export const BlueCrayola = '#2E72FD';
export const YaleBlue = '#154689';
export const OrangeRYB = '#F39400';
export const GoldenPoppy = '#f9c001';
export const GraniteGray = '#666666';
export const DarkElectricBlue = '#4A607B';
export const SunsetOrange = '#F45959';
export const Gray = '#7b7b7b';
export const AliceBlue = '#EDF9FF';
export const LavenderBlush = '#FFEDF9';
export const Honeydew = '#EDFFF3';
export const AirSuperiorityBlue = '#71A3C2';
export const Blueberry = '#468BEE';
export const PictonBlue = '#43BDEA';
export const GammaBlue = '#15BBE7';
export const BeauBlue = '#BADEEC';
export const MayaBlue = '#62C4EB';
export const Purple = '#b43bef';
export const Iris = '#6441c7';
export const LightSilver = '#D9D9D9';
export const SpanishGray = '#999999';
export const AmericanGreen = '#43BF48';
export const AntiFlashWhite = '#F3F3F3';
export const ChineseWhite = '#E0E0E0';
export const SonicSilver = '#767779';
